import { atom } from 'jotai';
import { Person } from '../../../schemas/Person.schema';

export const peopleReportingStateJ = atom<Person[]>([]);
